import React from "react";
import ThemedModal from "../../../utilities/ThemedModal";
import ReportFeedbackList from "./ReportFeedbackList";
import ReportMessagesList from "./ReportMessagesList";
import ReportStatusHistory from "./ReportStatusHistory";
import LoadingMessage from "../../../loaders/LoadingMessage";
import { DialogBody } from "./DialogBody";
import { NavigationContainer, NavigationTab } from "./DialogNavigation";
import { ClientReportHistoryModalProps } from "../types";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useReportHistory } from "../hooks/ReportHistoryContext";
import { Modal } from "react-bootstrap";
import { Button } from "../../..";
import { ReportReadonlyMessage } from "../../../messages";
import { Tabs, TabScreen } from "react-tabs-scrollable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { ModalMessageContainer } from "../../../messages/ModalMessageContainer";

const ClientReportHistoryModal = ({ 
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    masterAccountId,
    reportId,
    show,
    size = "xl",
    ...rest
} : Readonly<ClientReportHistoryModalProps>) => {
    const [bodyAnimation] = useAutoAnimate();
    const [activeTab, setActiveTab] = React.useState(0);
    const { error, isLoading, isReportEditable, report } = useReportHistory();

    const onClose = () => cancel!();

    const onTabClick = (e, i) => {
        e.preventDefault();
        setActiveTab(i);
    };

    // const { id, masterAccountId, reportName } = selectedReport;
    return (
        <Modal className="overflow-visible" backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header className="border-0" closeButton>
                {isLoading && (
                    <Modal.Title>Report History: Loading...</Modal.Title>
                )}
                {!isLoading && (
                    <Modal.Title>Report History: {error || !report ? 'Error' : report.reportName}</Modal.Title>
                )}
            </ThemedModal.Header>
            <DialogBody ref={bodyAnimation}>
                {isLoading && (
                    <LoadingMessage text="Please wait while we get the Report History" />
                )}
                {!isLoading && (!report || error) && (
                    <ModalMessageContainer variant="danger" text="There was a problem getting the Report History." />
                )}
                {!isLoading && !error && report && (
                    <>
                        <NavigationContainer>
                            <Tabs 
                                activeTab={activeTab} 
                                onTabClick={onTabClick}
                                leftBtnIcon={<FontAwesomeIcon icon={faChevronLeft} />}
                                rightBtnIcon={<FontAwesomeIcon icon={faChevronRight} />}
                            >
                                <NavigationTab icon="fa-chart-pie" label="Summary" />
                                <NavigationTab icon="fa-comment-dots" label="Feedback" />
                                <NavigationTab icon="fa-comment-alt" label="Messages & Notifications" />
                            </Tabs>
                        </NavigationContainer>
                        <TabScreen activeTab={activeTab} index={0} className="overflow-auto">
                            {!isReportEditable && <ReportReadonlyMessage />}
                            <ReportStatusHistory masterAccountId={masterAccountId} reportId={reportId} />
                        </TabScreen>
                        <TabScreen activeTab={activeTab} index={1} className="overflow-auto">
                            {!isReportEditable && <ReportReadonlyMessage />}
                            <div className="pt-3">
                                <ReportFeedbackList masterAccountId={masterAccountId} reportId={reportId} />
                            </div>
                        </TabScreen>
                        <TabScreen activeTab={activeTab} index={2} className="px-2 py-3" style={{ flex: '1 1 auto' }}>
                            <ReportMessagesList masterAccountId={masterAccountId} reportId={reportId} />
                        </TabScreen>
                    </>
                )}
            </DialogBody>
            <Modal.Footer>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ClientReportHistoryModal;